function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }

    this.updateCurrentVariantCard();
    this.updateMediaVariant();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;

    if (this.dataset.url != "") {
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const is_modal = document.querySelector("modal-quick-add") ? true : false;

    if (is_modal) {
      let handle = document
        .querySelector("modal-quick-add .product-card__link")
        .getAttribute("href")
        .split("products/")[1];
      console.log(handle);
      fetch(`/products/${handle}?variant=${requestedVariantId}&view=modal`)
        .then((response) => response.text())
        .then((responseText) => {
          // prevent unnecessary ui changes from abandoned selections
          if (this.currentVariant.id !== requestedVariantId) return;

          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const price = document.querySelector(
            `modal-quick-add .price__container`
          );
          if (html.querySelector(".price__container")) {
            price.innerHTML = html.querySelector(".price__container").innerHTML;
          }

          if (html.querySelector("[data-sku]")) {
            document.querySelector("modal-quick-add [data-sku]").innerHTML =
              html.querySelector("[data-sku]").innerHTML;
          }
        });
      this.toggleAddButton(
        !this.currentVariant.available,
        window.variantStrings.soldOut
      );
    } else {
      fetch(
        `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
          this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
        }`
      )
        .then((response) => response.text())
        .then((responseText) => {
          // prevent unnecessary ui changes from abandoned selections
          if (this.currentVariant.id !== requestedVariantId) return;

          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const destination = document.getElementById(
            `price-${this.dataset.section}`
          );
          const source = html.getElementById(
            `price-${
              this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section
            }`
          );
          const skuSource = html.getElementById(
            `Sku-${
              this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section
            }`
          );
          const skuDestination = document.getElementById(
            `Sku-${this.dataset.section}`
          );
          const inventorySource = html.getElementById(
            `Inventory-${
              this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section
            }`
          );
          const inventoryDestination = document.getElementById(
            `Inventory-${this.dataset.section}`
          );

          if (source && destination) destination.innerHTML = source.innerHTML;
          if (inventorySource && inventoryDestination)
            inventoryDestination.innerHTML = inventorySource.innerHTML;
          if (skuSource && skuDestination) {
            skuDestination.innerHTML = skuSource.innerHTML;
            skuDestination.classList.toggle(
              "visibility-hidden",
              skuSource.classList.contains("visibility-hidden")
            );
          }

          const price = document.querySelector(`.price__container`);

          console.log(price);

          if (html.querySelector("modal-quick-add .price__container")) {
            price.innerHTML = html.querySelector(
              "modal-quick-add .price__container"
            ).innerHTML;
          }
          if (html.querySelector(".price__container")) {
            price.innerHTML = html.querySelector(".price__container").innerHTML;
          }

          if (inventoryDestination)
            inventoryDestination.classList.toggle(
              "visibility-hidden",
              inventorySource.innerText === ""
            );

          this.toggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut
          );

          if (html.querySelector("[data-sku]")) {
            document.querySelector("[data-sku]").innerHTML =
              html.querySelector("[data-sku]").innerHTML;
          }
        });
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonSticky = document.querySelector(".add-to-cart-sticky");
    const productFormAvailability = document.querySelector(
      ".product-form__availability "
    );

    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (addButtonSticky) addButtonSticky.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
      if (addButtonSticky && text) addButtonSticky.textContent = text;
      productFormAvailability.classList.add("hidden");
    } else {
      addButton.removeAttribute("disabled");
      if (addButtonSticky) addButtonSticky.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
      if (addButtonSticky)
        addButtonSticky.textContent = window.variantStrings.addToCart;
      productFormAvailability.classList.remove("hidden");
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonSticky = document.querySelector(".add-to-cart-sticky");
    let productFormAvailability = document.querySelector(
      ".product-form__availability "
    );

    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (addButtonSticky)
      addButtonSticky.textContent = window.variantStrings.unavailable;

    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateCurrentVariantCard() {
    this.querySelectorAll(".product-form-collection__card").forEach((card) => {
      card.classList.toggle(
        "actif",
        card.dataset.variantId === this.currentVariant.id.toString()
      );
    });
  }

  updateMediaVariant() {
    let active_item =
      document.querySelector(".select.select__select select") ||
      document.querySelector(".product-form__input input:checked");
    if (active_item) {
      active_item = active_item.value;
      let variant_image = document.querySelector(
        '.image__variant[alt="' + active_item + '"]'
      );
      let variants_image = document.querySelectorAll(".image__variant");

      if (variant_image) {
        variants_image.forEach((item) => {
          if (item.closest(".swiper-slide-item")) {
            item
              .closest(".swiper-slide-item")
              .classList.add("swiper-slide-item");
            item.closest(".swiper-slide-item").classList.add("hidden");
            item
              .closest(".swiper-slide-item")
              .classList.remove("selected", "swiper-slide");
          }
          item.classList.remove("selected");
        });
        if (variant_image.closest(".swiper-slide-item")) {
          variant_image
            .closest(".swiper-slide-item")
            .classList.add("selected", "swiper-slide");
          variant_image
            .closest(".swiper-slide-item")
            .classList.remove("hidden");
        }
        variant_image.classList.add("selected");
      }
      if (document.querySelector(".image__variant.selected")) {
        let img_url = document.querySelector(".image__variant.selected").src;
        document.querySelector(".product-sticky-bar__image").src = img_url;
      }
    }
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

window.addEventListener("load", () => {
  toggleAlignBottom();
  window.addEventListener("resize", toggleAlignBottom);
});

function toggleAlignBottom() {
  if (
    window.innerWidth >= 990 &&
    document.querySelector(".product-form__container")
  ) {
    let description_height =
      document.querySelector(".product-form__container").offsetHeight + 150;
    if (document.querySelectorAll(".image__variant:not(.hidden").length == 0) {
      if (window.innerHeight < description_height) {
        document
          .querySelector(".main-product__form")
          .classList.add("align-bottom");
        document.querySelector(".main-product").classList.add("align-bottom");
      } else {
        if (document.querySelector(".main-product__form")) {
          document
            .querySelector(".main-product__form")
            .classList.remove("align-bottom");
        }
        if (document.querySelector(".main-product")) {
          document
            .querySelector(".main-product")
            .classList.remove("align-bottom");
        }
      }
    }
  }
}

class productCard extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.initSlider();
    this.productId = "";

    this.querySelector("[data-add-to-cart]")
      ? this.querySelector("[data-add-to-cart]").addEventListener(
          "click",
          this.checkVariant.bind(this)
        )
      : null;
    this.querySelector("[data-open-modal]")
      ? this.querySelector("[data-open-modal]").addEventListener(
          "click",
          this.checkVariant.bind(this)
        )
      : null;
  }

  initSlider() {
    this.swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: 1,
      spaceBetween: 0,
      allowTouchMove: this.closest('main-collection') ? true : false,
      treshold: 10,
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        990: {
          allowTouchMove: false,
        },
      },
    });
  }
  checkVariant(e) {
    if (e.currentTarget.classList.contains("open--modal")) {
      e.preventDefault();

      console.log("open modal");
      this.openModal(e);
    } else {
      this.addToCart(e);
    }
  }

  addToCart(e) {
    this.productId = e.currentTarget.getAttribute("data-variant-id");
    console.log(this.productId);
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: this.productId.toString(),
        quantity: 1,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data);
        window.dispatchEvent(
          new CustomEvent("cart:updated", {
            bubbles: true,
            detail: {
              id: this.productId,
              properties: {},
            },
          })
        );
        console.log("Added to Cart");
      });
  }

  openModal(e) {
    this.productId = e.currentTarget.getAttribute("data-product-handle");
    console.log(this.productId);
    let url = window.location.href.indexOf('/en') > -1 ? '/en' : "";
    url += `/products/${this.productId}?view=modal`
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        document.querySelector("main").insertAdjacentHTML("afterend", data);
        var scriptElement = document.createElement("script");
        scriptElement.src = quickAddScript;
        scriptElement.classList.add("modal-script");
        scriptElement.type = "text/javascript";
        document.body.appendChild(scriptElement);
        document.body.classList.add("shadow-modal");
        document
          .querySelector(".modal-quick-add__container")
          .classList.add("modal-active");
        document.addEventListener("click", (e) => {
          if (e.target.closest(".modal-active") === null) {
            document.querySelector("body").classList.remove("shadow-modal");
            const elem = document.querySelector("modal-quick-add");
            if (elem) {
              elem.parentElement.removeChild(elem);
            }
            const script = document.querySelector(".modal-script");
            if (script) {
              script.parentElement.removeChild(script);
            }
          }
        });

        document.querySelector(".loader-modal").classList.add("deactivate");
      });
  }
}

customElements.define("product-card", productCard);

// (function () {
//   var scrollFired = false;

//   function saveScroll() {
//     if (window.localStorage) {
//       window.localStorage.setItem(
//         "scrollLeftTop",
//         window.pageXOffset + "," + window.pageYOffset
//       );

//     }
//   }

//   function autoScroll() {
//     scrollFired = true;
//     if (window.localStorage) {
//       var xy = window.localStorage.getItem("scrollLeftTop");
//       if (xy) {
//         var a = xy.split(",");
//         var x = a[0];
//         var y = a[1];
//         window.scroll(x, y);
//       }
//     }
//   }

//   function onLoadAutoScroll() {
//     if (scrollFired === false) {
//       //Prevent scroll if run DOMContentLoaded
//       autoScroll();
//     }
//   }

//   window.addEventListener("DOMContentLoaded", autoScroll, false);
//   window.addEventListener("load", onLoadAutoScroll, false); //If DOMContentLoaded not "run"
//   window.addEventListener("scroll", saveScroll, false);
// })();

class sliderCollection extends HTMLElement {
  constructor() {
    super();

    this.swiper = null;

    this.initSlider();
    setTimeout(this.resizeFeaturedPicture.bind(this), 500);
    window.addEventListener("resize", this.resizeFeaturedPicture.bind(this));

    this.addEventListener("reload", () => {
      this.swiper.destroy();
      this.initSlider();
    });
  }

  initSlider() {
    if (this.dataset.enableSlider == "false") return;
    this.swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: "auto",
      spaceBetween: 0,
      centerInsufficientSlides: true,
      preventClicks: true,
      preventClicksPropagation: true,
      touchMoveStopPropagation: false,
      a11y: false,
      speed: 400,
      threshold: 15,
      navigation: {
        nextEl: this.querySelector(
          ".swiper-collection-product-container > .swiper-buttons .swiper-button-next"
        ),
        prevEl: this.querySelector(
          ".swiper-collection-product-container > .swiper-buttons .swiper-button-prev"
        ),
      },
      scrollbar: {
        el: this.querySelector(".swiper-scrollbar"),
        draggable: true,
      },
      breakpoints: {
        989: {
          cssMode: false,
        },
      },
    });
  }

  resizeFeaturedPicture() {
    if (this.querySelector(".slider-collection__featured__image")) {
      this.querySelector(".slider-collection__featured__image").style.height =
        this.querySelector(".product-card__media").getBoundingClientRect()
          .height + "px";
    }
  }
}

customElements.define("slider-collection", sliderCollection);

class sliderImages extends HTMLElement {
  constructor() {
    super();

    this.swiper = null;
    this.initSlider();
  }

  initSlider() {
    this.swiper = new Swiper(this, {
      slidesPerView: "auto",
      spaceBetween: 16,
      navigation: {
        nextEl: this.closest(".slider-images").querySelector(
          ".swiper-button-next"
        ),
        prevEl: this.closest(".slider-images").querySelector(
          ".swiper-button-prev"
        ),
      },
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
      scrollbar: {
        el: this.querySelector(".swiper-scrollbar"),
        draggable: true,
      },
      breakpoints: {
        749: {
          spaceBetween: 32,
        },
      },
    });
  }
}

customElements.define("slider-images", sliderImages);

class productsList extends HTMLElement {
  constructor() {
    super();

    this.swiper = null;
    this.initSlider();
  }

  initSlider() {
    this.swiper = new Swiper(this, {
      slidesPerView: "auto",
      spaceBetween: 16,
      threshold: 15,
      navigation: {
        nextEl: this.closest(".products-list").querySelector(
          ".swiper-button-next"
        ),
        prevEl: this.closest(".products-list").querySelector(
          ".swiper-button-prev"
        ),
      },
      scrollbar: {
        el: this.querySelector(".swiper-scrollbar"),
        draggable: true,
      },
      breakpoints: {
        749: {
          spaceBetween: 32,
        },
      },
    });
  }
}

customElements.define("products-list", productsList);

class feedInsta extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.getImagesFetch = false;
    this.images_container = document.querySelectorAll(".feed-insta__image");
    this.initSlider();
    this.getImage();

    window.addEventListener("scroll", this.getImage.bind(this));
  }

  initSlider() {
    this.swiper = new Swiper(this.querySelector(".feed-insta__images"), {
      slidesPerView: 1.4,
      spaceBetween: 16,
      navigation: {
        nextEl: this.closest(".feed-insta").querySelector(
          ".swiper-button-next"
        ),
        prevEl: this.closest(".feed-insta").querySelector(
          ".swiper-button-prev"
        ),
      },
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
      scrollbar: {
        el: this.querySelector(".swiper-scrollbar"),
        draggable: true,
      },
      breakpoints: {
        750: {
          slidesPerView: 1.8,
          spaceBetween: 16,
        },
        990: {
          slidesPerView: 3.8,
          spaceBetween: 16,
        },
        1200: {
          slidesPerView: 3.8,
          spaceBetween: 32,
        },
        1400: {
          slidesPerView: 4.3,
          spaceBetween: 32,
        },
      },
    });
  }

  getImage() {
    if (window.scrollY > 400 && this.getImagesFetch == false) {
      this.getImagesFetch = true;
      fetch(
        "https://d3ejra0xbg20rg.cloudfront.net/instagram/media?shop=aurelie-bidermann-eshop.myshopify.com&resource=default"
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
        })
        .then(
          function (json) {
            this.injectFeed(json);
          }.bind(this)
        )
        .catch((error) => {
          ////console.log(error);
        });
    }
  }

  injectFeed(feed) {
    ////console.log(feed);

    var index = 0;

    for (const image in feed) {
      if (index <= 10) {
        var current = feed[image];
        if (current.media_url.split(".mp4").length == 1) {
          this.images_container[index]
            .querySelector("a")
            .setAttribute("href", current.permalink);
          this.images_container[index]
            .querySelector("a")
            .setAttribute("target", "_blank");
          this.images_container[index]
            .querySelector("img")
            .setAttribute("src", current.media_url);
          index++;
        }
      }
    }
  }
}

customElements.define("feed-insta", feedInsta);
